import React from 'react';
import { Card } from "@/components/ui/card";
import GameImage from "@/components/GameImage";
import WordBlanks from "@/components/WordBlanks";
import GameHeader from "@/components/GameHeader";
import GameStats from "@/components/GameStats";
import GameFooter from "@/components/GameFooter";

interface GameContainerProps {
  correctWord: string;
  gameWon: boolean;
  guess: string;
  submittedGuess: string;
  isShaking: boolean;
  allCorrectLetters: Set<string>;
  revealed: boolean;
  timerRunning: boolean;
  wrongAttempts: number;
  onGuessChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onKeyDown: (e: React.KeyboardEvent) => void;
  onReveal: () => void;
  onTimerUpdate: (time: string) => void;
  inputRef: React.RefObject<HTMLInputElement>;
  finalTime?: string;
  currentImageIndex: number;
  onNextImage: () => void;
  onPrevImage: () => void;
  images: string[];
  placeholder: string;
  socialMediaUsername: string;
  socialMediaLink: string;
  showRevealButton: boolean;
}

const GameContainer: React.FC<GameContainerProps> = ({
  correctWord,
  gameWon,
  guess,
  submittedGuess,
  isShaking,
  allCorrectLetters,
  revealed,
  timerRunning,
  wrongAttempts,
  onGuessChange,
  onKeyDown,
  onReveal,
  onTimerUpdate,
  inputRef,
  finalTime = "",
  currentImageIndex,
  onNextImage,
  onPrevImage,
  images,
  placeholder,
  socialMediaUsername,
  socialMediaLink,
  showRevealButton
}) => {
  const handleTwitterShare = () => {
    const tweetText = `I gooned to ${correctWord} in ${finalTime} seconds!\n#goonguessr\n`;
    const twitterUrl = `https://twitter.com/intent/tweet?text=${encodeURIComponent(tweetText)}`;
    window.open(twitterUrl, '_blank');
  };

  return (
    <Card className="w-full max-w-md mx-auto bg-white p-6 shadow-md rounded-xl">
      <GameHeader />
      
      <GameImage 
        imageUrls={images}
        currentImageIndex={currentImageIndex}
        onNextImage={onNextImage}
        onPrevImage={onPrevImage}
        altText="Game Image" 
        gameWon={gameWon} 
      />
      
      <div className="space-y-4">
        <WordBlanks 
          correctWord={correctWord} 
          gameWon={gameWon} 
          isShaking={isShaking}
          currentGuess={guess}
          submittedGuess={submittedGuess}
          allCorrectLetters={allCorrectLetters}
          revealed={revealed}
        />
        
        <GameStats 
          timerRunning={timerRunning}
          onTimerUpdate={onTimerUpdate}
          gameWon={gameWon}
          revealed={revealed}
          finalTime={finalTime}
          guess={guess}
          onGuessChange={onGuessChange}
          onKeyDown={onKeyDown}
          inputRef={inputRef}
          disabled={gameWon || revealed}
          placeholder={placeholder}
          socialMediaUsername={socialMediaUsername}
          socialMediaLink={socialMediaLink}
        />
        
        {showRevealButton && !revealed && !gameWon && (
          <button
            onClick={onReveal}
            className="w-full mt-2 py-2 px-4 bg-gray-200 hover:bg-gray-300 text-gray-700 rounded transition-colors"
          >
            STOP EDGING
          </button>
        )}
      </div>

      <GameFooter 
        gameWon={gameWon}
        revealed={revealed}
        onTwitterShare={handleTwitterShare}
      />
    </Card>
  );
};

export default GameContainer;
